import { Children, isValidElement, useEffect, type ReactNode } from 'react'

import type { HeadProps } from './types'

export type { HeadProps } from './types'

function titleFrom(children: ReactNode): string | null {
  let title: string | null = null
  Children.forEach(children, (child) => {
    if (isValidElement<{ children?: ReactNode }>(child) && child.type === 'title') {
      const text = Children.toArray(child.props.children)
        .map((node) => (typeof node === 'string' || typeof node === 'number' ? String(node) : ''))
        .join('')
      title = text
    }
  })
  return title
}

/**
 * next/head, reduced to what this app uses: a <title>. The 16 call sites set
 * nothing else (inventory in plan 03). Restores the previous title on unmount,
 * as Next's head manager did when a page's Head left the tree.
 */
export default function Head(props: HeadProps): null {
  const title = titleFrom(props.children)
  useEffect(() => {
    if (title === null) return
    const previous = document.title
    document.title = title
    return () => {
      document.title = previous
    }
  }, [title])
  return null
}
